import { render, staticRenderFns } from "./OldIdcardTemplate.vue?vue&type=template&id=0d9c5a61"
import script from "./OldIdcardTemplate.vue?vue&type=script&lang=js"
export * from "./OldIdcardTemplate.vue?vue&type=script&lang=js"
import style0 from "./OldIdcardTemplate.vue?vue&type=style&index=0&id=0d9c5a61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports